import {Injectable} from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {FlightFieldGroup} from '../../interfaces/FlightFieldGroup';
import {FlightService} from '../../../dashboard/services/flight/flight.service';
import {Headers} from '@angular/http';
import {
  Action, AnyAction,
  PhotoActionData,
} from '../../../utilities/interfaces/Actions';

@Injectable()
export class FlightFieldGroupService {
  private route = 'flightfieldgroup';
  private action = 'action';

  constructor(private http: AuthHttp, private flightService: FlightService) {
  }

  public getFlightFieldGroup(flightId, type, signature?) {
    const params = <any>{type: type};
    if (signature)
      params.signature = signature;
    return this.http.get(`${environment.baseUrl}${this.route}/${flightId}`, {params: params})
      .map(res => res.json()).toPromise();
  }

  public addAdhocServices(data, flightId) {
    return this.http.post(`${environment.baseUrl}flight/${flightId}/adhoc-services`, data)
      .map(res => res.json()).toPromise();
  }

  public update(flightFieldGroup: FlightFieldGroup): Promise<any> {
    this.flightService.clearCache(); // when a field group is updated the cache for the flight needs to be dumped.
    return this.http.put(`${environment.baseUrl}${this.route}`, flightFieldGroup)
      .map(res => res.json()).toPromise();
  }

  public deleteMany(data, flightId) {
    return this.http.post(`${environment.baseUrl}${this.route}/${flightId}/delete`, data)
      .map(res => res.json()).toPromise();
  }

  public removeAdHocServices(adHocServiceIds: number[], flightId: number) {
    return this.http.post(`${environment.baseUrl}flight/${flightId}/adhoc-services/removeMany`, adHocServiceIds)
      .map(res => res.json()).toPromise();
  }

  public getActivitiesAndEvents(flightId: number) {
    return this.http.get(`${environment.baseUrl}activities-and-events/${flightId}`)
      .map(res => res.json()).toPromise();
  }

  public sendAction(action: AnyAction,
                    throwError = false) {
    return this.http.post(`${environment.baseUrl}${this.action}`, action, {
      throwError: throwError
    })
      .map(res => res.json()).toPromise();
  }

  public sendPhotoAction(action: Action<PhotoActionData>) {
    const data = new FormData();

    data.append('photo', action.data.uri);
    data.append('action', JSON.stringify(action));
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + localStorage.getItem('id_token'));
    headers.append('Accept', 'application/json');
    const options = {
        method: 'POST',
        headers: headers
    };
    return this.http.post(`${environment.baseUrl}uploadPhoto`, data, options)
      .map(res => res.json()).toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-renderer/services/flight-field-group/flight-field-group.service.ts